export var getCanonicalURL = function getCanonicalURL(url) {
  return url.replace(/(^[^(\\?|#)]+)(?:\\?|#).*/, '$1').replace(/\/+$/g, '');
};